import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "pa-4" }
const _hoisted_2 = { class: "d-flex align-center mb-4" }
const _hoisted_3 = { class: "d-flex align-center" }
const _hoisted_4 = { class: "font-weight-bold" }
const _hoisted_5 = { class: "text-caption text-medium-emphasis" }
const _hoisted_6 = {
  key: 0,
  class: "text-body-2 mt-1"
}
const _hoisted_7 = { class: "d-flex align-center" }
const _hoisted_8 = { class: "font-weight-bold" }
const _hoisted_9 = { class: "text-caption text-medium-emphasis" }
const _hoisted_10 = {
  key: 0,
  class: "text-body-2 mt-1"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[5] || (_cache[5] = _createElementVNode("h2", { class: "text-h5 font-weight-bold" }, "Aprobări Manager", -1)),
      (_ctx.totalPending > 0)
        ? (_openBlock(), _createBlock(_component_v_chip, {
            key: 0,
            class: "ml-3",
            color: "red-darken-1",
            variant: "tonal"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.totalPending) + " în așteptare ", 1)
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      _createVNode(_component_v_spacer),
      _createVNode(_component_v_btn, {
        icon: "mdi-refresh",
        variant: "text",
        onClick: _ctx.incarca,
        loading: _ctx.loading
      }, null, 8, ["onClick", "loading"])
    ]),
    _createVNode(_component_v_tabs, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tab) = $event)),
      color: "red-darken-1",
      class: "mb-4"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_tab, { value: "concedii" }, {
          default: _withCtx(() => [
            _createTextVNode("Concedii (" + _toDisplayString(_ctx.concedii.length) + ")", 1)
          ]),
          _: 1
        }),
        _createVNode(_component_v_tab, { value: "documente" }, {
          default: _withCtx(() => [
            _createTextVNode("Documente (" + _toDisplayString(_ctx.documente.length) + ")", 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_window, {
      modelValue: _ctx.tab,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tab) = $event))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_window_item, { value: "concedii" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.concedii, (c) => {
              return (_openBlock(), _createBlock(_component_v_card, {
                key: c.ID,
                elevation: "1",
                class: "mb-3",
                rounded: "lg"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_4, _toDisplayString(c.NumeAngajat), 1),
                          _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.formatDate(c.DataInceput)) + " — " + _toDisplayString(_ctx.formatDate(c.DataSfarsit)) + " · " + _toDisplayString(c.NumarZile) + " zile · " + _toDisplayString(c.TipConcediu), 1),
                          (c.Descriere)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(c.Descriere), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "green",
                          variant: "tonal",
                          size: "small",
                          class: "mr-2",
                          onClick: ($event: any) => (_ctx.actiune(c.ID, 'concediu', true))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                                _createTextVNode("mdi-check", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[7] || (_cache[7] = _createTextVNode(" Aprobă ", -1))
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          color: "red",
                          variant: "tonal",
                          size: "small",
                          onClick: ($event: any) => (_ctx.actiune(c.ID, 'concediu', false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                _createTextVNode("mdi-close", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[9] || (_cache[9] = _createTextVNode(" Respinge ", -1))
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (!_ctx.loading && _ctx.concedii.length === 0)
              ? (_openBlock(), _createBlock(_component_v_alert, {
                  key: 0,
                  type: "info",
                  variant: "tonal"
                }, {
                  default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                    _createTextVNode("Nu există cereri de concediu în așteptare.", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }),
        _createVNode(_component_v_window_item, { value: "documente" }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.documente, (d) => {
              return (_openBlock(), _createBlock(_component_v_card, {
                key: d.ID,
                elevation: "1",
                class: "mb-3",
                rounded: "lg"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_card_text, null, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("div", null, [
                          _createElementVNode("div", _hoisted_8, _toDisplayString(d.NumeAngajat), 1),
                          _createElementVNode("div", _hoisted_9, _toDisplayString(d.TipDenumire), 1),
                          (d.Descriere)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(d.Descriere), 1))
                            : _createCommentVNode("", true)
                        ]),
                        _createVNode(_component_v_spacer),
                        _createVNode(_component_v_btn, {
                          color: "green",
                          variant: "tonal",
                          size: "small",
                          class: "mr-2",
                          onClick: ($event: any) => (_ctx.actiune(d.ID, 'document', true))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                                _createTextVNode("mdi-check", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[12] || (_cache[12] = _createTextVNode(" Aprobă ", -1))
                          ]),
                          _: 1
                        }, 8, ["onClick"]),
                        _createVNode(_component_v_btn, {
                          color: "red",
                          variant: "tonal",
                          size: "small",
                          onClick: ($event: any) => (_ctx.actiune(d.ID, 'document', false))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_icon, null, {
                              default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                                _createTextVNode("mdi-close", -1)
                              ]))]),
                              _: 1
                            }),
                            _cache[14] || (_cache[14] = _createTextVNode(" Respinge ", -1))
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]),
                    _: 2
                  }, 1024)
                ]),
                _: 2
              }, 1024))
            }), 128)),
            (!_ctx.loading && _ctx.documente.length === 0)
              ? (_openBlock(), _createBlock(_component_v_alert, {
                  key: 0,
                  type: "info",
                  variant: "tonal"
                }, {
                  default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                    _createTextVNode("Nu există cereri de documente în așteptare.", -1)
                  ]))]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_v_dialog, {
      modelValue: _ctx.dialogObs,
      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.dialogObs) = $event)),
      "max-width": "420",
      persistent: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { rounded: "xl" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.actiunePendinga?.aprobare ? 'Aprobare' : 'Respingere'), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_textarea, {
                  modelValue: _ctx.observatie,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.observatie) = $event)),
                  label: "Observație (opțional)",
                  variant: "outlined",
                  density: "compact",
                  rows: "3"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_btn, {
                  variant: "text",
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.dialogObs = false))
                }, {
                  default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                    _createTextVNode("Anulează", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: _ctx.actiunePendinga?.aprobare ? 'green' : 'red',
                  loading: _ctx.actLoading,
                  onClick: _ctx.confirmActiune
                }, {
                  default: _withCtx(() => [...(_cache[17] || (_cache[17] = [
                    _createTextVNode("Confirmă", -1)
                  ]))]),
                  _: 1
                }, 8, ["color", "loading", "onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}